import { useIntl } from 'react-intl';

import { Picture } from '@/components/wpl/image/src/image';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { ProductPageSubNav } from '@/patterns/global-nav/src/nav-product-page';

export const RovoDevNav = () => {
	const intl = useIntl();

	const signupLink = useLocalizedHref('/try/cloud/signup?bundle=devai');
	const pricingHref = useLocalizedHref('/software/rovo-dev/pricing');
	const documentationHref = useLocalizedHref(
		'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents',
	);

	const logo = (
		<Picture
			image={{
				src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg',
				alt: 'Rovo Dev',
			}}
			style={{ height: '26px' }}
		/>
	);

	return (
		<ProductPageSubNav
			productLogoUrl="/software/rovo-dev"
			productLogo={logo}
			productLogoAriaLabel={intl.formatMessage({
				id: 'RovoDevNav.productLogoAriaLabel',
				defaultMessage: 'Rovo Dev logo',
			})}
			mobileCtaText={intl.formatMessage({
				id: 'RovoDevNav.tryItFree',
				defaultMessage: 'Try it Free',
			})}
			navigationTrynowCtaText={intl.formatMessage({
				id: 'RovoDevNav.tryItFree',
				defaultMessage: 'Try it Free',
			})}
			mobileCtaUrl={signupLink}
			mobileLogo={logo}
			productPageNavLinks={[
				{
					globalLinksKey: 'pricing',
					linkText: intl.formatMessage({
						id: 'RovoDevNav.pricing',
						defaultMessage: 'Pricing',
					}),
					hasSubnav: false,
					productKey: 'rovoDev',
					href: pricingHref,
				},
				{
					globalLinksKey: 'documentation',
					linkText: intl.formatMessage({
						id: 'RovoDevNav.documentation',
						defaultMessage: 'Documentation',
					}),
					hasSubnav: false,
					productKey: 'rovoDev',
					href: documentationHref,
				},
			]}
			navigationTrynowCtaUrl={signupLink}
			mobileLinksSections={[
				{
					mobileLinkKey: 'mobile-rovo-dev',
					mobileLinksProps: [
						{
							globalLinksKey: 'pricing',
							linkText: intl.formatMessage({
								id: 'RovoDevNav.pricing',
								defaultMessage: 'Pricing',
							}),
							hasSubnav: false,
							productKey: 'rovoDev',
							href: pricingHref,
						},
						{
							globalLinksKey: 'documentation',
							linkText: intl.formatMessage({
								id: 'RovoDevNav.documentation',
								defaultMessage: 'Documentation',
							}),
							hasSubnav: false,
							productKey: 'rovoDev',
							href: documentationHref,
						},
					],
				},
			]}
		/>
	);
};
